<div *ngIf="section" class="section">{{section}}</div>
